console.log('🧵 Cart-drawer.js carregado');


// Função que faz o AJAX do add-to-cart e abre a gaveta
function handleAddToCart(form) {
  return async function(e) {
    e.preventDefault();
    const data = new FormData(form);
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json' }
    });
    if (!resp.ok) return; // se der erro, sai sem abrir
    // 1) Tenta abrir o drawer nativo
    if (window.theme?.cartDrawer?.open) {
      return theme.cartDrawer.open();
    }
    // 2) Senão, dispara o clique no widget do Storista
    const storista = document.querySelector('[data-type="storista"]');
    if (storista) {
      return storista.click();
    }
    // 3) Se ainda assim nada, abre pelo atributo padrão
    document.querySelector('[data-cart-drawer]')?.classList.add('is-open');
  }
}

// Função que anexa os listeners aos forms de add-to-cart
function initCartInterception() {
  document
    .querySelectorAll('form[action^="/cart/add"]')
    .forEach(form => form.addEventListener('submit', handleAddToCart(form)));
}

// Se já carregou, executa agora; senão espera o DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartInterception);
} else {
  initCartInterception();
}
